module.exports = "/_next/static/images/banner_yellowpick_1200.GJOUQvPK.png";